export default function UpdatesSection() {
  const updates = [
    {
      date: '2026-07-31',
      title: '暑期档新片批量上线',
      desc: '本周新增多部暑期档热门影片，包括国内外最新上映的动作、科幻、喜剧大片，高清片源已就位。',
      tag: '片源更新',
    },
    {
      date: '2026-07-28',
      title: '网站域名安全升级通知',
      desc: '为保障用户访问安全，777影院全系列域名（含7777影院、777777影院、77777影院）已完成HTTPS安全证书更新。',
      tag: '站点公告',
    },
    {
      date: '2026-07-25',
      title: '纪录片专区内容扩充',
      desc: '纪录片分类新增BBC《地球脉动》全系列、国家地理精选专辑，高清画质，中文字幕。',
      tag: '内容扩充',
    },
    {
      date: '2026-07-22',
      title: '移动端观影体验优化',
      desc: '针对手机和平板设备的播放体验进行了全面优化，适配更多屏幕尺寸，加载速度提升30%。',
      tag: '体验优化',
    },
    {
      date: '2026-07-18',
      title: '日韩剧集同步更新加速',
      desc: '与多家字幕组达成合作，热门日韩电视剧更新延迟缩短至12小时内，追剧体验全面升级。',
      tag: '更新提速',
    },
    {
      date: '2026-07-15',
      title: '用户反馈通道正式开通',
      desc: '网站底部新增问题反馈和投稿入口，欢迎广大影迷提出宝贵意见和优质内容推荐。',
      tag: '功能上线',
    },
    {
      date: '2026-07-10',
      title: '经典港片修复版上线',
      desc: '精心整理的上世纪八九十年代经典港片高清修复版已上线，重温黄金时代的银幕记忆。',
      tag: '经典回归',
    },
  ];

  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            777影院运营动态与内容更新一览
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200">
            {updates.map((update, i) => (
              <div
                key={i}
                className={`relative pb-10 ${i === updates.length - 1 ? 'pb-0' : ''}`}
              >
                {/* Timeline dot */}
                <div className="absolute -left-[25px] md:-left-[29px] top-0.5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 ring-2 ring-primary-200/50"></div>

                <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-300/40 transition-all duration-300 cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-500">{update.date}</span>
                    <span className="px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                      {update.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 mb-1.5">
                    {update.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {update.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}